import * as React from 'react';
const SvgCode = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
        <path
            d="M6.033 2.667H3.141v4.5L1.333 8.772v.321m0 0l.362.322m-.362-.322l1.808 1.607v4.5h2.892M12.3 2.667h2.892v4.499L17 8.773v.321m0 0l-.361.321M17 9.094l-1.808 1.607V15.2H12.3M11.524 6.583L6.54 11.568"
            stroke="currentColor"
            strokeWidth={1.7}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SvgCode;
